module.exports = __webpack_public_path__ + "media/images/index-hero-badge-tl-55a5c76604dc40c5b916af4c406325f3.svg";